const footerNav = [
  { label: '实时进展', href: '#live' },
  { label: '热点直击', href: '#feed' },
  { label: '辟谣实锤对照', href: '#compare' },
  { label: '专题合集', href: '#collection' },
  { label: '反转热度榜', href: '#rank' },
  { label: '当事人回应', href: '#timeline' },
  { label: '理性讨论', href: '#discuss' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 pb-8 pt-12 md:px-6 md:pt-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-empathize-line text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black tracking-wide text-background-50">抖阴黑料</span>
                <span className="mt-1 text-[11px] text-background-300">辟谣 · 反转 · 真相追踪</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              本站围绕辟谣、反转与真相追踪，汇总当事人回应与后续进展，将澄清与实锤并排呈现，帮助你理性看待吃瓜信息。
            </p>
            <div className="mt-4 flex items-center gap-1.5 rounded-lg bg-background-50/5 px-3 py-2.5 text-xs leading-relaxed text-background-200/70">
              <i className="ri-information-line text-accent-300" />
              网络信息真伪请以当事人回应与官方公告为准，站内内容仅为追踪整理。
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-wide text-background-50">快速导航</h4>
            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {footerNav.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="group inline-flex cursor-pointer items-center gap-1 text-sm text-background-200/80 transition-colors hover:text-background-50">
                    <i className="ri-arrow-right-s-line text-xs text-accent-400 transition-transform group-hover:translate-x-0.5" />
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold tracking-wide text-background-50">内容板块</h4>
            <ul className="mt-3 flex flex-col gap-2.5 text-sm text-background-200/80">
              <li><a href="#feed" className="cursor-pointer transition-colors hover:text-background-50">反转真相速览</a></li>
              <li><a href="#compare" className="cursor-pointer transition-colors hover:text-background-50">辟谣与实锤对照</a></li>
              <li><a href="#timeline" className="cursor-pointer transition-colors hover:text-background-50">当事人回应时间线</a></li>
              <li><a href="#rank" className="cursor-pointer transition-colors hover:text-background-50">反转热度榜</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-5 text-xs text-background-300/70 sm:flex-row">
          <span>© 2026 抖阴黑料 · 理性吃瓜，关注反转真相与当事人回应</span>
          <a href="#top" className="inline-flex cursor-pointer items-center gap-1 transition-colors hover:text-background-50">
            <i className="ri-arrow-up-line" /> 回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}